export const ALL_ASSOCIATIONS = '__all__';

const KEY = 'hl-association-view';

export type AssociationView = 'all' | 'one';

export function associationView(): AssociationView | null {
    const value = sessionStorage.getItem(KEY);
    return value === 'all' || value === 'one' ? value : null;
}

export function setAssociationView(view: AssociationView): void {
    sessionStorage.setItem(KEY, view);
    window.dispatchEvent(new Event('hl-association-view'));
}
